export const BIKE_MERCHANDISE_CATEGORIES = new Set([
  "S0101",
  "S010301",
  "S010302",
]);
export const SKI_MERCHANDISE_CATEGORIES = new Set(["S0213"]);

export function categoryStartsWith(
  category: string,
  prefixes: Set<string>
): boolean {
  return [...prefixes].some((prefix) => category.startsWith(prefix));
}

/**
 * Merchandise category codes read "S" + division + product group + subgroup,
 * e.g. S010601 = bike (01) apparel (06) jerseys (01). Fit Analytics sizes
 * apparel (06) and footwear (07) in every division.
 */
const FITANALYTICS_MERCHANDISE_CATEGORY = /^S\d{2}0[67]/;

export function getShowFitAnalyticsWidget(
  merchandiseCategory: string
): boolean {
  return FITANALYTICS_MERCHANDISE_CATEGORY.test(merchandiseCategory);
}

export function getShowSmartfitWidget(
  variantProducts: Array<{ merchandiseCategory?: string | null }>
): boolean {
  const MERCHANDISE_CATEGORIES = new Set([
    ...BIKE_MERCHANDISE_CATEGORIES,
    ...SKI_MERCHANDISE_CATEGORIES,
  ]);

  return variantProducts.some((variant) =>
    categoryStartsWith(
      variant.merchandiseCategory ?? "",
      MERCHANDISE_CATEGORIES
    )
  );
}
